import { useEffect } from "react"

// hook handles click outside of the passed element
function useClickOutside(callback: () => void, node?: HTMLElement | null, exceptNodes?: (HTMLElement | null | undefined)[]): void {
    function removeEventListener(handler: (event: Event) => void) {
        document.removeEventListener("mousedown", handler);
        document.removeEventListener("touchstart", handler);
    }
    useEffect(() => {
        function handleClickOutside(event: Event) {
            const target = event.target as Node

            if (exceptNodes?.length) {
                for (let exceptedNode of exceptNodes) {
                    if (exceptedNode && exceptedNode.contains(target)) {
                        return
                    }
                }
            }

            if (!node?.contains(target)) {
                callback()
            }
        }

        if (!node) {
            removeEventListener(handleClickOutside)
            return
        }

        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => removeEventListener(handleClickOutside)
    }, [node, callback, exceptNodes])
}

export default useClickOutside
